import { render, staticRenderFns } from "./ret-tree.vue?vue&type=template&id=384f2aba&scoped=true&"
import script from "./ret-tree.vue?vue&type=script&lang=js&"
export * from "./ret-tree.vue?vue&type=script&lang=js&"
import style0 from "./ret-tree.vue?vue&type=style&index=0&id=384f2aba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384f2aba",
  null
  
)

export default component.exports